<template lang="html">
    <entity-page id="page__printer" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <z-input 
            v-model="printer.name" id="name" name="name" label="Название"
            v-bind:error="errors.first('name')" v-validate="'required|min:1|max:255'"
            data-vv-name="name" v-bind:data-vv-as="' '"
        ></z-input>
        <z-input 
            v-model="printer.ip" id="ip" name="ip" label="IP"
            v-bind:error="errors.first('ip')" v-validate="{required: true, min: 4, max: 20, regex: ipValidate}"
            data-vv-name="ip" v-bind:data-vv-as="' '"
        ></z-input>
        <z-input 
            v-model="printer.port" id="port" name="port" label="Порт"
            v-bind:error="errors.first('port')" v-validate="'required|min:1|max:255'"
            data-vv-name="port" v-bind:data-vv-as="' '"
        ></z-input>
        <z-select
            v-model="printer.stock_id" id="stock_id" name="stock_id" label="Склад"
            v-bind:error="errors.first('stock_id')" v-validate="'required'"
            data-vv-name="stock_id" v-bind:data-vv-as="' '">
            <option v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id">{{ stock.name }}</option>
        </z-select>
        <z-select
            v-model="printer.status_id" id="status_id" name="status_id" label="Статус"
            v-bind:error="errors.first('status_id')" v-validate="'required'"
            data-vv-name="status_id" v-bind:data-vv-as="' '"
        >
            <option v-bind:value="1" v-bind:key="1">Не установлен</option>
            <option v-bind:value="2" v-bind:key="2">Онлайн</option>
            <option v-bind:value="3" v-bind:key="3">Отключен</option>
        </z-select>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZSelect     from '@/components/ZSelect';
    import ZIconButton from '@/components/ZIconButton';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: { ZInput, ZIconButton, EntityPage, ZSelect },
        data() {
            return {
                ipValidate: /^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/,
                printer: {
                    name:     null,
                    ip:       null,
                    port:     null,
                    stock_id: null,
                    status_id: 0
                },
                printerDefault: {
                    name:     null,
                    ip:       null,
                    port:     null,
                    stock_id: null,
                    status_id: 0
                }
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-printer-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список принтеров
             */
            printers() {
                return this.$store.state.stock.printers;
            },
            /**
             * Список складов
             */
            stocks() {
                return this.$store.state.stock.stocks;
            },
        },
        watch: {
            '$route.params.id'() {
                this.init();
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.getPrinter();
                this.$store.commit('openRightPanel');
            },
            /**
             * Получение принтера
             */
            getPrinter() {
                if (this.$route.params.id == 'new') return (this.printer = Object.assign({}, this.printerDefault));
                this.$store.commit('showProgressBar', 'load-printer-card');
                return this.$store.dispatch('stock/getPrinter', {id: this.$route.params.id})
                    .then(printer => this.printer = Object.assign({}, printer))
                    .finally(() => this.$store.commit('hideProgressBar', 'load-printer-card'));
            },
            /**
             * Добавление принтера
             */
            postPrinter() {
                this.$store.commit('showProgressBar', 'load-printer-card');
                this.$store.dispatch('stock/postPrinter', this.printer).then(r => {
                    if (!r) return;
                    this.$router.replace({name: 'Printer', params: {id: r.id}});
                    this.$root.$emit('reload-table', 'printers');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-printer-card'))
            },
            /**
             * Изменение принтера
             */
            putPrinter() {
                this.$store.commit('showProgressBar', 'load-printer-card');
                this.$store.dispatch('stock/putPrinter', this.printer).then(() => {
                    this.init();
                    this.$root.$emit('reload-table', 'printers');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-printer-card'))
            },
            /**
             * сохранение принтера
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.id == 'new') this.postPrinter();
                    else this.putPrinter();
                });
            },
            /**
             * Возврат на предидущую страницу
             */
            back() {
                this.$router.push({name: 'Printers', query: this.$route.query});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Printer.vue?11b05cc4